export default __webpack_public_path__ + "static/FeatureKlimtMobile-bb2a5e1f3ba3df2e47abf8a849164b74.png";